<p-dialog [(visible)]="isLoading" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false">
  <div class="flex justify-content-center align-items-center">{{ loadingDialogService.getMessage() }}</div>
</p-dialog>